<template>
    <div class='projects-filter-wrapper'>
        <!-- <div><span style="font-size: 24px;
    padding: 9px;position: relative;
    top: 10px;">Project name goes here</span></div> -->
        
        <!-- <li v-show="isFilterRequired('projects')">
            <div class="config-value">
                <div style="display: inline-flex" class="w-100">
                    <div class="d-inline-flex edit-icon-visibility" style="width:100%;">
                            <Multiselect
                            v-model="selectedProject"
                            :options="allProjectsList"
                            :searchable="false"
                            :close-on-select="true"
                            :allow-empty="false"
                            label="project_name"
                            deselectLabel=""
                            selectLabel=""
                            selectedLabel=""
                            track-by="_id"
                            @select="onProjectChange($event)"
                            >
                            <span slot="noResult">No results.</span>
                        </Multiselect>
                    </div>
                </div>       
            </div>
        </li> -->


        <!-- <div style="position:relative;display:flex;" :style="filterContext != undefined ? 'justify-content:flex-start':'justify-content:flex-end;'"> -->
            <!-- <li>
                <div class="config-value">
                    <div style="display: inline-flex" class="w-100">
                        <div class="d-inline-flex edit-icon-visibility" style="width:100%;">
                            <input
                                type="text"
                                style="position:relative;top:3px"
                                class="rounded text-light comm-input-field-style"
                                placeholder="Search issues or tasks"
                                v-model.number="requestingQueryParameters.keyword"
                                autocomplete="off"
                                @input="sendFilteredparametrs()"
                            />
                        </div>
                    </div>       
                </div>
            </li> -->

            <li v-show="isFilterRequired('status')" class="status-field task-status-filter" :style="!allowToEditTaskIssue?'pointer-events:none':''" :class="getColorToStatus(selectedReviewStatus)" style=" margin: 3px !important;">
                <div class="config-value">
                    <div style="display: inline-flex" class="w-100">
                        <div class="d-inline-flex edit-icon-visibility" style="width:100%;">
                                <Multiselect
                                v-model="selectedReviewStatus"
                                :options="reviewStatusList"
                                :searchable="true"
                                :close-on-select="true"
                                :allow-empty="false"
                                deselectLabel=""
                                track-by="_id"
                                label="status_name"
                                selectLabel=""
                                selectedLabel=""
                                placeholder="Status"
                                :custom-label="statusLabelCallBack"
                                @search-change="getStatusOfStatusTypesOptions($event)"
                                @select="updateSelectedStatus($event)"
                                :style="allowToEditTaskIssue==true?'pointer-events:auto':'pointer-events:none'"
                                >
                                <!-- :style="allowToEditTaskIssue==true?'pointer-events:auto':'pointer-events:none'" -->
                                
                                <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                    <span style="margin-inline-start:12px;">{{ scope.option.status_name }}</span>
                                </div>
                                <span slot="noResult">No results.</span>
                            </Multiselect>
                        </div>
                    </div>       
                </div>
            </li>

            <li v-show="isFilterRequired('users') && !isClientUser()" style="margin: 3px 0px 3px 0px !important;">
                <!-- <div class="config-label">Assignee</div> -->
                <div class="config-value">
                    <div style="display: inline-flex" class="w-100">
                        <div class="d-inline-flex edit-icon-visibility" :title="(!projectUsersList || projectUsersList.length ==0)?'No Project Selected':''" style="width:100%;">  <!-- @click="!projectUsersList || projectUsersList.length == 0? showNoProjectAlert():''" -->
                            <users-multiselect 
                                :enableCheckbox="filterContext == 'Tasks'? false:true" 
                                :isSearchable="true" 
                                @updatedUsersList='handleAssigneeUsersList' 
                                @removedUserFromList='handleAssigneeUsersListOnRemove'
                                :customizeLabel="getfieldLabel('Assignee')"
                                :loggedInUserDataList="selecetedTaskInfo != undefined? assigneeIdList : ''"
                                :filterContext="filterContext"
                                @checkForUnsavedDescription="checkForUnsavedDescription"
                                :filterByUT="getPrefferedUserTypes()"
                                :specificContextUsersList="projectUsersList"
                                
                            ></users-multiselect>
                        </div> 
                    </div>       
                </div>
            </li>
            <li v-show="isFilterRequired('priority')" style="margin: 3px 0px 3px 0px !important;">
                <div class="config-value">
                    <div style="display: inline-flex" class="w-100">
                        <div class="d-inline-flex edit-icon-visibility" style="width:100%;">
                            <Multiselect
                                :value="'Priority : ' + selectedReviewPriority"
                                :options="reviewPriorityList"
                                :searchable="false"
                                :close-on-select="true"
                                :allow-empty="false"
                                deselectLabel=""
                                selectLabel=""
                                selectedLabel=""
                                @open="checkForUnsavedDescription"
                                @select="onReviewPriorityChange($event)"
                                >
                                <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                                <span style=""><svg class="svg-icon" style="top:0px;margin:0px" fill="currentColor" v-html="getPriorityIcon(scope.option)"> </svg>{{ scope.option }}</span>
                                </div>
                                <span slot="noResult">No results.</span>
                            </Multiselect>
                        </div>
                    </div>       
                </div>
            </li>
            <!-- <li v-show="isFilterRequired('type')">
                <div class="config-value">
                    <div style="display: inline-flex" class="w-100">
                        <div class="d-inline-flex edit-icon-visibility" style="width:100%;">
                                <Multiselect
                                :value="'Type : ' + selectedTaskType"
                                :options="taskTypes"
                                :searchable="false"
                                :close-on-select="true"
                                :allow-empty="false"
                                deselectLabel=""
                                selectLabel=""
                                selectedLabel=""
                                @select="onTypeFilterChange($event)"
                                >
                                <span slot="noResult">No results.</span>
                            </Multiselect>
                        </div>
                    </div>       
                </div>
            </li> -->
           
            <li v-show="isFilterRequired('start_date')" v-if="filterContext == 'Tasks'" class="comm-div" style="margin-inline-end:10px;width:12% !important; margin: 3px 6px 3px 0 !important;">
                <div class="config-value"> 
                    <!-- <label class="config-label">Date</label> -->
                    <Datepicker
                        @open="showUserFilter=false, checkForUnsavedDescription()"
                        v-model="time1"
                        valueType="format"
                        @change="OnStartDateChange()"
                        class="rounded  text-light"
                        style="height:38px !important;"
                        placeholder="Select Start date"
                    ></Datepicker>
                </div>    
            </li>

            <li v-show="isFilterRequired('due_date')" v-if="filterContext == 'Tasks'" class="comm-div" style="margin-inline-end:10px;width:12% !important; margin: 3px 6px 3px 0 !important;">
                <div class="config-value"> 
                    <Datepicker
                        @open="showUserFilter=false, checkForUnsavedDescription()"
                        v-model="time2"
                        valueType="format"
                        @change="OnEndDateChange()"
                        class="rounded  text-light"
                        style="height:38px !important;"
                        placeholder="Select Due date"
                    ></Datepicker>
                </div>    
            </li>
            
           
            <li v-on:click="extendWidth($event)" v-show="isFilterRequired('cc_users')" v-if="filterContext == 'Tasks'" class="comm-div" style="margin-inline-end:10px; margin: 3px 6px 3px 0 !important;">
                <div class="config-value" style="display:inline-block"> 
                    <div v-if="enableEditMode != true && defaultCCsCheck == false" class="rounded mx-datepicker" style="height:38px !important"> 
                        <input v-model="ccList" @input="onCCUsersChange(ccList)" type="text" :placeholder="'CC'" id="task_ccs_field" class="mx-input-wrapper mx-input" title="Ex: abc@mail.com,xyz@mail.com" style="color: #f8f9fa !important">
                    </div> 
                    <div v-else style="width:100%;display: inline-flex;height:100%;"> 
                      <div class="w-100" style="width:100% !important">
                        <div class="d-inline-flex edit-icon-visibility" style="height:100%">
                            <span v-show="!isCCsEditing" style="border: 1px solid #4a4a4a;padding: 5px 10px;border-radius: 4px;font-size:14px;display: inline-block;position:relative;margin-inline-end:10px;word-break: break-word;line-height:1.9;min-width:150px;">CC: {{ccList}}
                            </span>
                            <edit-icon
                              @click.native="editCCsField(selecetedTaskInfo.cc_users)"
                              v-show="!isCCsEditing"
                              class="edit-icon"
                            ></edit-icon>
                        </div>
                        
                        </div>
                        <div v-show="isCCsEditing" class="taskTitleSaveUnsaveBtns" >
                            <input
                                minlength="3"
                                type="text"
                                v-model="ccValue"
                                v-show="isCCsEditing"
                                class="rounded text-light comm-input-field-style-cc-edit"
                                placeholder="CC"
                                style="position:relative;"
                                autocomplete="off"
                                title="Ex: abc@mail.com,xyz@mail.com"
                            />
                            <div class="d-flex">
                              <save-icon
                               @click.native="onCCUsersChange(ccValue)"
                              ></save-icon>
                              <cancel-icon
                                @click.native="cancelSelectedReviewFields('cc_users')" >
                              </cancel-icon>
                            </div>
                          </div>
                        </div>
                </div>    
            </li>
           
        <!-- </div> -->
    </div>    

</template>

<script>
    import {mapActions,mapGetters, mapMutations} from "vuex";
    import Utils from '../../components.utils.js';
    import Multiselect from 'vue-multiselect';
    import userMultiSelect from "../users/UserMultiselectField.vue"
    import DatePicker from "vue2-datepicker";
    import EditIcon from "../core/InlineEditField.vue";
    import SaveIcon from "../core/InlineSaveField.vue";
    import CancelIcon from "../core/InlineCancelField.vue";

    export default {
        props:["selectedProjectFromTicket","allowToEditTaskIssue", "selecetedTaskInfo", "disableAll", "selectedOptionFromSideMenu","filtersNotRequiredList", "filterContext","enableEditMode", "projectUsersList"],
        data(){
            return{
                // selectedReviewStatus :"All",
                // reviewStatusList:["All", "New", "Done", "In Progress"],
                // selectedReviewPriority:"All",
                // reviewPriorityList:["All", "Highest", "High", "Medium", "Low", "Lowest"],
                // taskTypes:["All","Issue","Task"],
                // selectedTaskType : "All",
                selectedReviewStatus : "",
                reviewStatusList : [],
                selectedReviewPriority : "Medium",
                reviewPriorityList : ["Highest", "High", "Medium", "Low", "Lowest"],
                taskTypes : ["Issue","Task"],
                selectedTaskType : "Task",
                selectedUsersList : [],
                selectedReporterList : [],
                assigneeIdList :[],
                loggedInUserList:[],
                requestingQueryParameters : {},
                searchedKeyword:"",
                allProjectsList : [],
                selectedProject:null,
                time1:null  ,
                time2:null,
                ccList:"",
                isCCsEditing:false,
                ccValue : "",
                defaultCCsCheck : false,
                selectedProjectFromParent:null
            }
        },
        
        components:{
            "Multiselect":Multiselect,
            "users-multiselect":userMultiSelect,
            "Datepicker":DatePicker,
            "edit-icon": EditIcon,
            "save-icon": SaveIcon,
            "cancel-icon": CancelIcon,
        },

        emits: ["getFilteredData"],

        methods:{
            isFilterRequired(name){
                if(!this.filtersNotRequiredList) return true;
                if(this.filtersNotRequiredList && Array.isArray(this.filtersNotRequiredList) && this.filtersNotRequiredList.length === 0) return true;
                if(this.filtersNotRequiredList.indexOf(name) > -1) return false;
                return true;
            },
            statusLabelCallBack(option){
                return `${'Status: ' + option.status_name}`
            },

            showNoProjectAlert(){
                alert("No Project is Selected")
            },

            handleAssigneeUsersList(user){
                // if(this.filterContext == 'Tasks'){
                    this.selectedUsersList = [];
                    if(user != "all"){
                        this.selectedUsersList.push(user.user_id);
                     }else if(user == "all"){
                        delete this.requestingQueryParameters.users;
                    }  
                // }else{
                //     if(user != "all"){
                //         this.selectedUsersList.push(user);
                //         // this.selectedUserInfo["_id"] = this.selectedUsersList;
                //     }else if(user == "all"){
                //         delete this.requestingQueryParameters.users;
                //     } 
                // }      
                //  this.requestingQueryParameters.users  = JSON.stringify(this.selectedUsersList);
                this.requestingQueryParameters.users  = this.selectedUsersList[0];
                this.sendFilteredparametrs("assignee"); 
            },

            handleAssigneeUsersListOnRemove(user){
                this.selectedUsersList = this.selectedUsersList.filter(e => e != user)
                if( this.selectedUsersList.length > 0){
                    // this.requestingQueryParameters.users  = JSON.stringify(this.selectedUsersList);
                    this.requestingQueryParameters.users  = this.selectedUsersList[0];
                }else if( this.selectedUsersList.length == 0){
                    delete this.requestingQueryParameters.users;
                }    
                this.sendFilteredparametrs("assignee"); 
            },
            onTypeFilterChange(option){
                this.selectedTaskType = option;
                if(typeof option != "undefined"){
                    this.requestingQueryParameters["task_type"] = option;
                }
                this.sendFilteredparametrs("task_type");  
            },

            onReviewPriorityChange(option){
                this.selectedReviewPriority = option;
                if(typeof option != "undefined"){
                    this.requestingQueryParameters["priority"] = option;
                }
                this.sendFilteredparametrs("priority");  
            },
            
            getStatusOfStatusTypesOptions(event){
                let payload = {'params':{}}
                payload.params = {'project_id':this.selectedProjectFromParent._id};
                if(this.$route.query.taskContext && this.$route.query.taskContext == 'Ticket'){
                    payload.params['task_type'] = "Ticket";
                    if(!this.selectedProjectFromParent || (this.selectedProjectFromParent && this.selectedProjectFromParent.length == 0)){
                        delete payload.params.project_id;
                    }else if(this.selectedProjectFromParent && this.selectedProjectFromParent._id){
                        if(payload.params.task_type)delete payload.params.task_type;
                        payload.params['project_id'] = this.selectedProjectFromParent._id;
                    }
                }
                if(event && event.length > 0){
                    payload.params['keyword'] = event;
                }
                
                this.getStatusAutocomplete(payload).then((data) => {
                    this.reviewStatusList = data.statuses;
                    let dIndex = this.reviewStatusList.findIndex(e => e.status_type == 'New' && e.default)
                    if(dIndex > -1 && !this.allowToEditTaskIssue){
                        this.selectedReviewStatus = this.reviewStatusList[dIndex];
                        this.requestingQueryParameters["status"] = this.selectedReviewStatus._id;
                        this.requestingQueryParameters["status_type"] = this.selectedReviewStatus.status_type;
                    }
                })
            },

            updateSelectedStatus(event){
                this.selectedReviewStatus = event;
                if(typeof event._id != "undefined"){
                    this.requestingQueryParameters["status"] = event._id;
                    this.requestingQueryParameters["status_type"] = event.status_type;
                }
                this.sendFilteredparametrs("status");  
            },

            onCCUsersChange(ccusers){
                console.log("ccusers are", ccusers)
                this.requestingQueryParameters["cc_users"] = ccusers;
                if(ccusers != ""){
                    if(this.enableEditMode == true || this.defaultCCsCheck == true){
                        let emailRegex= new RegExp(/^([a-z0-9._%+-]+)@([a-z0-9.]+)\.([a-z]{2,3})(\.[a-z]{2,3})?$/);
                        let ccUsersListTemp = ccusers.replaceAll(" ", "").split(",")
                        if(ccUsersListTemp.length>0){
                            let emailValidate = true;
                            for(let i = 0; i < ccUsersListTemp.length ; i++){
                                if (emailRegex.exec(ccUsersListTemp[i]) == null) {
                                    emailValidate = false;
                                    break;
                                }
                            }
                            if(emailValidate == false){
                                this.$toast.error("Please use valid CC mail Ids");
                                return false;
                            }
                        }
                    } 
                }       

                this.sendFilteredparametrs("cc_users"); 
                this.isCCsEditing = false;
                if (this.enableEditMode == true || this.defaultCCsCheck == true){
                    this.selecetedTaskInfo.cc_users =  ccusers;
                    if (![null, undefined].includes(this.selecetedTaskInfo.cc_users && ccusers != "")){
                        let ccUsersList = this.selecetedTaskInfo.cc_users.replaceAll(" ", "").split(",")
                        this.ccList = ccUsersList[0] + " +"+(ccUsersList.length - 1);
                    }
                }
            },

            OnStartDateChange(){
                this.time1 = this.time1+"T00:00:00"
                if(this.time1 > this.time2 ){
                    alert("Due date Should be greater than start date");
                    this.time1 = null;
                    return false;
                }
                if(typeof this.time1 != "undefined" && this.time1 != null && !this.time1.startsWith("null")){
                    this.requestingQueryParameters.start_date = this.time1;
                }else if(this.time1 == null || this.time1.startsWith("null")){
                    this.requestingQueryParameters.start_date = "";
                }else{
                    delete this.requestingQueryParameters.start_date;
                }
                this.sendFilteredparametrs("start_date");              
            },

            OnEndDateChange(){
                this.time2 = this.time2+"T23:59:59"
                if(this.time1 > this.time2 ){
                    alert("Due date Should be greater than start date");
                    this.time2 = null;
                    return false;
                }
                if(typeof this.time2 != "undefined" && this.time2 != null && !this.time2.startsWith("null")){
                   this.requestingQueryParameters.due_date = this.time2;
                }else if(this.time2 == null || this.time2.startsWith("null")){
                    this.requestingQueryParameters.due_date = "";
                }else{
                    delete  this.requestingQueryParameters.due_date;
                }
                this.sendFilteredparametrs("due_date");              
            },
            
            onProjectChange(option){
                this.selectedProject = option;
                if(option._id != "all"){
                    if(option != null){
                        this.requestingQueryParameters["project_id"] = option._id;
                    }
                }else{
                    delete this.requestingQueryParameters.project_id;
                }    
                this.sendFilteredparametrs("project_id");    
            },

            getProjectOptionsList(){
                // this.getServerProjectsData().then((data) =>{
                // if(![undefined, null].includes(Utils.getCookieValue('pam_projects_list'))){
                 if(![undefined, null].includes(localStorage.getItem('pam_projects_list')) && !this.isClientUser()){           
                    this.allProjectsList = JSON.parse(localStorage.getItem('pam_projects_list'));
                    this.selectedProject = this.allProjectsList[0];
                    this.$nextTick(()=>{
                        if (this.selectedProject != null && Object.keys(this.selectedProject).includes('_id')){
                            this.requestingQueryParameters["project_id"] = this.selectedProject._id;
                            this.sendFilteredparametrs();
                        }
                    });    
                }    
                // });    
            },

            sendFilteredparametrs(filterType){
                // this.requestingQueryParameters.page = 1;
                console.log("requestingQueryParametersrequestingQueryParameters",this.requestingQueryParameters)
                this.$emit("getFilteredData", this.requestingQueryParameters);
                this.$emit("filterType", filterType);
            },

            isPrivilegeExists(privilegeName){
                return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege, privilegeName);
            },

            getfieldLabel(label){
                return label;
            },

            getColorToStatus(state){
                if (state.status_type == "Done") return 'greenBackground'; if (state.status_type == "New") return 'blueBackground'; if (state.status_type == "In Progress") return 'orangeBackground';
            },
            
            getPriorityIcon(priority){
                let priorityIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z" fill:"#f7ab00" stroke="#f7ab00"/>
</svg>`;
                if(priority == "Highest"){
                    priorityIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z" fill="#fb3a0e" stroke="#fb3a0e"/>
</svg>`;
                }else if(priority == "High"){
                    priorityIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z" fill="#fb572f" stroke="#fb572f"/>
</svg>`;
                }else if(priority == "Medium"){
                    priorityIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z" fill:"#f7ab00" stroke="#f7ab00"/>
</svg>`;
                }else if(priority == "Low"){
                    priorityIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-down" viewBox="0 0 16 16"  stroke="#b5b5b5">
  <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"/>
</svg>`;   
                }else if(priority == "Lowest"){
                    priorityIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-down" viewBox="0 0 16 16" stroke="#808080">
  <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"/>
</svg>`;   
                }

                return priorityIcon;
            },

            checkForUnsavedDescription(){
                this.$emit("checkIsUnsavedDescription", true);
            },

            editCCsField(ccUserList){
              console.log(ccUserList)
              this.isCCsEditing = true;
              if (ccUserList != undefined || ccUserList != null){
                this.ccValue = ccUserList;
              }else if (this.defaultCCsCheck == true){
                  this.ccValue = this.getLoggedInUserInfo.default_assignees;
              }
            },

            cancelSelectedReviewFields(keyName) {
                if(keyName == "cc_users"){
                  this.isCCsEditing = false;
                }
            },

            extendWidth(event){
                console.log("event", event)
                event.target.style.width="22% !important";
            },

            getPrefferedUserTypes(){
                if(['SystemAdmin','SystemUser'].includes(this.getLoggedInUserType())){
                    return ['SystemAdmin','SystemUser'];
                }
                return [];
            },

             handleTasksNotificationInFilters(notification){
                 notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
                if(notification.message){
                    let task_info = notification.message;
                    if (notification.message_type == "TASK_MODIFIED"){
                            // this.$toast.info("'"+ notification.message.task.task_tag +"' is Updated");
                        if(this.selecetedTaskInfo._id == task_info._id){
                            // Object.assign(this.selecetedTaskInfo, task_info.task); //--- this line if for to update whole dictionary of comment
                            
                            if(Object.keys(task_info).includes("assignee_name") && Object.keys(task_info).includes("assignee_id") && !this.isClientUser()){
                                this.selectedUsersList = [],
                                this.assigneeIdList = [];
                                let assigneeObj = {};
                               
                               assigneeObj["username"] = task_info.assignee_name;
                                assigneeObj["_id"] = task_info.assignee_id;
                                this.assigneeIdList.push(assigneeObj);
                                
                            }
                            if(Object.keys(task_info).includes("status")){
                                if(task_info.status && task_info.status_type && task_info.status_name){
                                    let dIndex = this.reviewStatusList.findIndex(e => e._id == task_info.status)
                                    if(dIndex > -1){
                                        this.selectedReviewStatus = this.reviewStatusList[dIndex];
                                        this.requestingQueryParameters["status"] = this.selectedReviewStatus._id;
                                        this.requestingQueryParameters["status_type"] = this.selectedReviewStatus.status_type;
                                    }else{
                                        let dtIndex = this.reviewStatusList.findIndex(e => e.status_type == task_info.status_type && e.default);
                                        if(dtIndex > -1){
                                            this.selectedReviewStatus = this.reviewStatusList[dtIndex];
                                            this.requestingQueryParameters["status"] = this.selectedReviewStatus._id;
                                            this.requestingQueryParameters["status_type"] = this.selectedReviewStatus.status_type;
                                        }
                                    }
                                }else{
                                    this.selectedReviewStatus['status'] = task_info.status;
                                }
                            }
                            if(Object.keys(task_info).includes("priority") && ((this.isClientUser() && task_info.modified_by_userId == this.getLoggedInUserId()) || !this.isClientUser())){
                                this.selectedReviewPriority = task_info.priority;
                            }
                            
                            if(Object.keys(task_info).includes("assignee_id") && ((this.isClientUser() && task_info.modified_by_userId == this.getLoggedInUserId()) || !this.isClientUser())){
                                this.selectedUsersList.push(task_info.assignee_id);
                            }

                            if(Object.keys(task_info).includes("start_date") && ((this.isClientUser() && task_info.modified_by_userId == this.getLoggedInUserId()) || !this.isClientUser())){
                                this.time1 = task_info.start_date;
                            }    

                            if(Object.keys(task_info).includes("due_date") && ((this.isClientUser() && task_info.modified_by_userId == this.getLoggedInUserId()) || !this.isClientUser())){
                                this.time2 = task_info.due_date;
                            } 
                            
                            if(Object.keys(task_info).includes('cc_users')){
                                this.selecetedTaskInfo.cc_users = task_info.cc_users.join(",");
                                if (task_info.cc_users.length >= 1  && task_info.cc_users != "" && task_info.cc_users != null){
                                    if(task_info.cc_users.length > 1){
                                        this.ccList = task_info.cc_users[0] + " +"+(task_info.cc_users.length - 1);
                                    }else{
                                        this.ccList = task_info.cc_users[0]
                                    }    
                                }else if (this.selecetedTaskInfo.cc_users.length == 0){
                                    this.ccList = ""
                                }
                            }

                        }  
                    }   
                }
            },

                registerforWebsocketNotifications(){
                    this.addWSEventListener({
                    eventname:["TASK_MODIFIED"],
                    callback:this.handleTasksNotificationInFilters,
                    parent: "reviewdisplay"});
                },
                unRegisterforWebsocketNotifications(){
                    this.removeWSEventListener({
                    eventname:["TASK_MODIFIED"],
                    callback:this.handleTasksNotificationInFilters,
                    parent: "reviewdisplay"});
                },

                isClientUser(){
                    if(this.getLoggedInUserType() == 'Client'){
                        return true;
                    }else{
                        return false;
                    }
                },

            ...mapActions("users", ["getAllUsersFromServer","getUsersAutoComplitionFromServer"]),
            ...mapGetters("users",["getLoggedInUser","getLoggedInUserId", "getLoggedInUserType"]),
            ...mapActions("PAM", ["getServerProjectsData","getStatusAutocomplete",'getIndividualStatusInfo']),
            ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
        },
        beforeDestroy(){
            this.unRegisterforWebsocketNotifications()
        },
        mounted(){
            this.getStatusOfStatusTypesOptions();
        },
        created(){
            this.getProjectOptionsList();
            // this.getStatusOfStatusTypesOptions();
            this.registerforWebsocketNotifications();
            
            if (Object.keys(this.getLoggedInUserInfo).includes('default_assignees') && this.getLoggedInUserInfo.default_assignees != "" && this.getLoggedInUserInfo.default_assignees != null
                && this.getLoggedInUserInfo.default_assignees.length >= 1){
                if(this.getLoggedInUserInfo.default_assignees.length > 1){
                    this.ccList = this.getLoggedInUserInfo.default_assignees[0] + " +"+(this.getLoggedInUserInfo.default_assignees.length - 1);
                }else{
                    this.ccList = this.getLoggedInUserInfo.default_assignees[0];
                }
                this.defaultCCsCheck = true;
            }

            this.selectedProjectFromParent = this.selectedProjectFromTicket;
            this.$nextTick(() => {
                let payload = {'params':{}}
                if(this.$route.query.taskContext && this.$route.query.taskContext == 'Task'){
                    payload.params = {'project_id':this.selectedProjectFromParent._id};
                }else if(this.$route.query.taskContext && this.$route.query.taskContext == 'Ticket'){
                    payload.params['task_type'] = "Ticket";
                    if(!this.selectedProjectFromParent || (this.selectedProjectFromParent && this.selectedProjectFromParent.length == 0)){
                        delete payload.params.project_id;
                    }else if(this.selectedProjectFromParent && this.selectedProjectFromParent._id){
                        payload.params = {'project_id':this.selectedProjectFromParent._id};
                        if(payload.params.task_type)delete payload.params.task_type;
                    }
                }else if(this.selectedProjectFromParent && Object.keys(this.selectedProjectFromParent).length > 0){
                    payload.params = {'project_id':this.selectedProjectFromParent._id};
                    if(payload.params.task_type)delete payload.params.task_type;
                }
                // this.getStatusAutocomplete(payload).then((data) => {
                //     this.reviewStatusList = data.statuses;
                //     if(!this.allowToEditTaskIssue){
                //         let dIndex = this.reviewStatusList.findIndex(e => e.status_type == 'New' && e.default)
                //         if(dIndex > -1){
                //             this.selectedReviewStatus = this.reviewStatusList[dIndex];
                //             this.requestingQueryParameters["status"] = this.selectedReviewStatus._id;
                //             this.requestingQueryParameters["status_type"] = this.selectedReviewStatus.status_type;
                //         }
                //     }
                // })
            })

            if(this.allowToEditTaskIssue == true){
                if(this.selecetedTaskInfo.status && this.selecetedTaskInfo.status_type && this.selecetedTaskInfo.status_name){
                    this.selectedReviewStatus = {'_id':this.selecetedTaskInfo.status,'status_type':this.selecetedTaskInfo.status_type,'status_name':this.selecetedTaskInfo.status_name};
                }else{
                    this.selectedReviewStatus = this.selecetedTaskInfo.status;
                }
                this.selectedReviewPriority = this.selecetedTaskInfo.priority;

                this.selectedUsersList = [], this.selectedUsersList.push(this.selecetedTaskInfo.assignee_id);

                let assigneeObj = {};
                assigneeObj["username"] = this.selecetedTaskInfo.assignee_name;
                assigneeObj["_id"] = this.selecetedTaskInfo.assignee_id;
                this.assigneeIdList.push(assigneeObj);

                if(this.selecetedTaskInfo.start_date != "" && this.selecetedTaskInfo.start_date != null){
                    this.time1 = this.selecetedTaskInfo.start_date;
                }
                
                if(this.selecetedTaskInfo.due_date != "" && this.selecetedTaskInfo.due_date != null){
                    this.time2 = this.selecetedTaskInfo.due_date;
                }
                
                if(Object.keys(this.selecetedTaskInfo).includes('cc_users') ){
                    if (this.selecetedTaskInfo.cc_users.length >= 1 && this.selecetedTaskInfo.cc_users != "" && this.selecetedTaskInfo.cc_users != null){
                        if(this.selecetedTaskInfo.cc_users.length > 1){
                            this.ccList = this.selecetedTaskInfo.cc_users[0] + " +"+(this.selecetedTaskInfo.cc_users.length - 1);
                        }else{
                            this.ccList = this.selecetedTaskInfo.cc_users[0];
                        }    
                    }else if (this.selecetedTaskInfo.cc_users.length == 0){
                        this.ccList = ""
                    }
                }
            }

            // if(this.filterContext == 'Tasks'){
                // this.selectedReviewStatus = "New";
                // this.reviewStatusList = ["New", "Done", "In Progress"];
                // this.selectedReviewPriority = "Medium";
                // this.reviewPriorityList = ["Highest", "High", "Medium", "Low", "Lowest"];
                // this.taskTypes = ["Issue","Task"];
                // this.selectedTaskType = "Task";
                
                // this.requestingQueryParameters["status"] = this.selectedReviewStatus;

                if(this.selecetedTaskInfo.status && this.selecetedTaskInfo.status_type && this.selecetedTaskInfo.status_name){
                    this.selectedReviewStatus = {'_id':this.selecetedTaskInfo.status,'status_type':this.selecetedTaskInfo.status_type,'status_name':this.selecetedTaskInfo.status_name};
                }else{
                    this.selectedReviewStatus = this.selecetedTaskInfo.status;
                }
                this.requestingQueryParameters["task_type"] = this.selectedTaskType;
                this.requestingQueryParameters["priority"] = this.selectedReviewPriority;
                
                this.sendFilteredparametrs();
            // }
        },
        watch:{
            selectedProjectFromTicket(newVal){
                this.selectedProjectFromParent = newVal;
                this.$nextTick(() => {
                    let payload = {'params':{}}
                    if(this.$route.query.taskContext && this.$route.query.taskContext == 'Task'){
                        payload.params = {'project_id':this.selectedProjectFromParent._id};
                    }else if(this.$route.query.taskContext && this.$route.query.taskContext == 'Ticket'){
                        payload.params['task_type'] = "Ticket";
                        if(!this.selectedProjectFromParent || (this.selectedProjectFromParent && this.selectedProjectFromParent.length == 0)){
                            delete payload.params.project_id;
                        }else if(this.selectedProjectFromParent && this.selectedProjectFromParent._id){
                            payload.params = {'project_id':this.selectedProjectFromParent._id};
                            if(payload.params.task_type)delete payload.params.task_type;
                        }
                    }else if(this.selectedProjectFromParent && Object.keys(this.selectedProjectFromParent).length > 0){
                        payload.params = {'project_id':this.selectedProjectFromParent._id};
                        if(payload.params.task_type)delete payload.params.task_type;
                    }
                    this.getStatusAutocomplete(payload).then((data) => {
                        this.reviewStatusList = data.statuses;
                            let dIndex = this.reviewStatusList.findIndex(e => e.status_type == 'New' && e.default)
                            if(dIndex > -1){
                                this.selectedReviewStatus = this.reviewStatusList[dIndex];
                                this.requestingQueryParameters["status"] = this.selectedReviewStatus._id;
                                this.requestingQueryParameters["status_type"] = this.selectedReviewStatus.status_type;
                            }
                    })
                })
            }
        },

        computed:{
            ...mapGetters("users",["getLoggedInUserPrivilege", "getLoggedInUserInfo"])
        },
    
    }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
    $border-color: 1px solid #4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $highlight-font-color:#ff9800;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555; 
    $input-field-padding:.375rem 10px;
    $filter-border-color: #5a5a5a;
    $filter-bg-color: #2a2a2a;

    input[type="checkbox"]:after {
        line-height: 1.5em;
        content: "";
        display: inline-block;
        width: 22px;
        height: 21px;
        margin-top: -1px;
        margin-inline-start: -1px;
        border: $border-color;
        border-radius: 0.25em;
        background: $primary-background;
    }

    input[type="checkbox"]:checked:after {
        content: "✔";
        color: $active-blue;
        font-size: 16px;
        line-height: 1;
        transition: all 0.2s;
        font-family: Helvetica, Arial, sans-serif;
        padding-inline-start: 4px;
        padding-top: 2px;
    }

    .thumbnail-data {
        svg {
            border-radius: 5px;
            height: 100%;
            width: 100%;
        }
    }

    .reduce-opacity{
        opacity: 0.67
    }

    .svg-icons-display {
        height: 20px;
        width: 20px;
        position: relative;
        opacity: 0.8;
        inset-inline-end: 5px;
    }

    .file-name {
        white-space: nowrap;
        width: 140px;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: initial;
        position: relative;
        inset-inline-start:2px;
        top: 2px;
    }

    .file-name-display-styles-in-list-view{
        // white-space: nowrap;
        // overflow: hidden;
        // text-overflow: ellipsis;
        // text-align: initial;
        width: 75%;
        text-align: start;
        padding: 8px 0px;
        display: inline-block;
        .comm-review-title{
            width: 100%;
            display: inline-block;
        }
        .comm-reivew-description{
            // white-space: nowrap;
            // overflow: hidden;
            // text-overflow: ellipsis;
            // text-align: initial;
            width: 100%;
            display: inline-block;
            color: $dull-text-color !important;
            font-size: 13px !important;
            padding-top: 2px;
        }
    }

    .user-name-or-image{
        height: 30px;
        width: 30px;
        border: $border-color;
        border-radius: 10px;
        text-align: center;
        line-height: 28px;
        text-transform: uppercase;
        margin-top: 3px;
    }    

    .user-name{
        margin-inline-end: 10px;
        position: relative;
        bottom: 7px;
    }

    .activeclass{
        color: $active-blue;
    }

    .user-name-align{
        text-align: start;
    }

    svg.svg-icon {
        width: 20px;
        height: 20px;
    }
    .comm-more-users-style{
        font-size: 10px !important;
        color: $text-color;
    }

     li {
      width: auto;
      display: inline-flex;
      // margin-bottom: 20px;
      float:inline-start;
    //   border: $border-color;
      margin: 0px 2px;
      border-radius: 5px;
      height: auto;
      height: 38px;
    }

    .config-label {
        width: 100% !important;
        text-align: end;
        color: $dull-text-color;
        word-break: break-word;
        position: relative !important;
        top: 9px !important;
        inset-inline-start:3px;
    }
  
    .config-value {
        // margin-inline-start: 4px;
        width: 100% !important;
        // display: grid;
        display:flex;
        align-items: center;
        svg{
            position: relative;
            top: 9px;
            margin-inline-start: 10px;
        }
    }

    .edit-icon-visibility{
        button.edit-icon{
            visibility: hidden;
        }
    }

    .edit-icon-visibility:hover{
        button.edit-icon{
            visibility: visible;
        }
    }

    .disabled-field{
        cursor: not-allowed;
        pointer-events: none;
    }

     ::v-deep {

        .greenBackground{
            .multiselect__tags{
                background:#58a75a !important;
            }
        }
    
        .orangeBackground{
            .multiselect__tags{
                background:#f37b15 !important;
            }
        }
    
        .blueBackground{
            .multiselect__tags{
                background:#2d99d9 !important;
            }
        }

        .projectDropdownFilter{
            .multiselect__tags{
                border: 0px !important;
                background: transparent !important;
            }
            .multiselect__single{
                font-size:24px !important;
                padding-top:0px !important;
            }
        }

        .mx-input{
            background-color:$primary-background!important;
            border: none !important;
            color: $dull-text-color !important;
            height:100%;
        }
        .mx-input-wrapper{
        width:100%;
        height:100%;
        }
        .mx-datepicker-main{
           border: $border-color !important;
        background: $secondary-background-color !important;
        }
        .mx-calendar-content .cell:hover{
            background-color:  $bg-color-on-hover !important;
        }
        .mx-datepicker-range{
        width:100%;
        height:100% !important;
        }
        .mx-calendar-content .cell:hover {
            color: #000000;
            background-color: #7d99b1;
        }
        .mx-datepicker{
        width:100% !important;
        padding: 0 !important;
        border:$border-color !important;
        height: 27px !important;
        }
        .mx-icon-calendar, .mx-icon-clear{
            color: #d7d2d280;
        }

        .page-item.disabled .page-link {
            background-color: $secondary-background-color !important;
            border: $border-color !important;
            // border: none;
        }
        .page-item.active .page-link {
            background-color: $secondary-background-color !important;
            // border: none !important;
            border: $border-color !important;
            color: $active-blue;
            z-index: 0 !important;
        }
        .page-link {
            background-color: $secondary-background-color !important;
            border: $border-color !important;
            // border: none !important;
            color: $text-color;
            padding: 5px !important;
        }
        .page-link:hover {
            background-color: $bg-color-on-hover !important;
        }
        .pagination {
            float: inline-end;
            margin-bottom: 0px !important;
            margin-inline-end: 8px;
        }
        .VuePagination__count {
            color: $secondary-text-color !important;
            margin-bottom: 0px !important;
            font-size: 12px;
            margin-inline-end: 7px;
            margin-top: 1px;
            float:inline-start;
            display:none;
            margin-inline-start:5px;
        }
        .VuePagination__pagination-item {
            font-size: 14px;
            width: 27px;
        }
        .VuePagination__pagination-item-prev-chunk {
            display:none;
        }
        .VuePagination__pagination-item-next-chunk{
            display:none;
        }

        .VuePagination__pagination-item-prev-page{
            width:50px !important;
        }

        .VuePagination__pagination-item-next-page{
            width:50px !important;
        }

        .VuePagination__pagination-item-next-page a:before{
            width:50px;
            content: "next ";
        }

        .VuePagination__pagination-item-prev-page a:after{
            width:50px;
            content: " prev";
        }
        .v-list{
            padding:0px !important;
        }
        .v-list-item{
            text-align: start;
            border: $border-color !important;
            min-height: 37px !important;
            padding: 0 10px !important;
            font-size: 12px !important;
            .v-list-item__title{
                    font-size: 14px !important;
                    color:$text-color !important;
            }
            }
        .v-menu__content{
            width:150px !important;
        }
        .multiselect{
            width:100%;
            margin: 3px 0px;
    }
    .multiselect__tags-wrap{
        display:block;
    }
    .multiselect__content-wrapper{
        display:none;
    }
    .multiselect__tag, .tags-style {
        background-color: $primary-background !important;
        border: $border-color;
        border-radius: 5px;
        margin-bottom:0px;
    }
    .multiselect__tags, .tags-style {
        background: $primary-background !important;
        border: $border-color !important;
    }
        .multiselect__option--highlight {
            background: $bg-color-on-hover !important;
        }
        .multiselect__content {
            background: $secondary-background-color !important;
        }
        .multiselect__input, .multiselect__single {
            background: transparent !important;
            color:$text-color;
        }
        .multiselect__input:focus{
            outline:none;
            box-shadow: none;
        }
        .multiselect__tag-icon{
        color:$text-color;
        }
        .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
            background: $bg-color-on-hover !important;
            color: $text-color !important;
        }
        .multiselect__tag-icon:after{
        color:$secondary-text-color !important;
        font-size: 20px;
        }
        .multiselect *{
            font-size: $input-field-and-label-font-size;
            font-family: "Roboto", Arial, sans-serif !important;
        }
        .multiselect__tags{
            padding: 6px 40px 0 8px!important;
        }
        .multiselect__placeholder {
            // padding-top: 5px !important;
            margin-bottom:0px;
            color:#5d5d5d !important;
        }
        .multiselect{
            color:$text-color !important;
            font-size: $input-field-and-label-font-size !important;
            min-height: 36px;
        }
        .multiselect__single{
                margin: 0!important;
                height: 100%;
                padding-top:0px !important;
        }
        .multiselect__option--selected{
            background:$bg-color-on-hover !important;
            color: $text-color;
        }
        .multiselect__content-wrapper{
            border: 1px solid $bg-color-on-hover !important;
            position: absolute;
            display: block;
            background: $text-color;
            width: 100%;
            max-height: 150px;
            overflow: auto;
            border: 1px solid $text-color;
            border-top: none;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            z-index: 50;
            -webkit-overflow-scrolling: touch;
        }
        .multiselect__select,.multiselect__current,.multiselect__option{
            line-height: 12px !important;
        }
        .multiselect--above .multiselect__content-wrapper{
        background: $secondary-background-color !important;
        }
        .multiselect__tags {
            background: $primary-background !important;
            height: auto;
        }
    }
    .comm-input-field-style{
         background: $primary-background !important;
        float: inline-start;
        width:100% !important;
        padding: $input-field-padding;
        border: $border-color!important;
        font-size:$input-field-and-label-font-size;
        height: $input-field-height;
    }

    .comm-input-field-style-cc-edit{
        background: $primary-background !important;
        float: inline-start;
        width:80% !important;
        padding: $input-field-padding;
        border: $border-color!important;
        font-size:$input-field-and-label-font-size;
        height: $input-field-height;
    }

    ::placeholder{
        color:#5f5f5f !important;
    }

    #task_ccs_field:focus{
        width:450px;
        transition: 0.5s;
    }

    .taskTitleSaveUnsaveBtns{
        // position: relative;
        margin-inline-start:1px;
        position: absolute;
        width: 90%;
        inset-inline-start:0px;
        svg{
        color: $text-color;
            // border: $border-color;
            background: $primary-background;
            margin-inline-end: 2px;
            margin-inline-start:3px;
        }
    }


</style>
